import { render, staticRenderFns } from "./UpsetPlot.vue?vue&type=template&id=7e9d8689&scoped=true"
import script from "./UpsetPlot.vue?vue&type=script&lang=js"
export * from "./UpsetPlot.vue?vue&type=script&lang=js"
import style0 from "./UpsetPlot.vue?vue&type=style&index=0&id=7e9d8689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9d8689",
  null
  
)

export default component.exports